import React from "react";
import { Link } from "react-router-dom";
import { NavigationContext } from "../../NavigationContext";
import SecureAPI from "../../SecureAPI";
import { Form, Col, Row, InputGroup, Button } from "react-bootstrap";
import { API_URL } from "../../utils/Constants";
import LoginWrapper from "./LoginWrapper";
import {
  LOGINPAGE_CONSTANTS,
  QKR_LOGIN_URL,
  API_AUTH_TOKEN,
  API_CONTEXT_TYPE,
  API_METHOD_GET,
  API_METHOD_POST,
  ADMIN_TYPE,
  ACCOUNT_LOCKED,
  REGEX_VALIDATIONS,
} from "../../config/constants";
import { ROUTES } from "../../config/routes";
import {
  WarningLogo,
  EyeOpenLogo,
  EyeHideLogo,
} from "../../assets/icons/index.js";

class LoginPage extends React.Component {
  static contextType = NavigationContext;
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      success: true,
      loginFailure: false,
      role: "",
      emailIdData: "",
      merchantIdData: "",
      schoolName: "",
      firstName: "",
      lastName: "",
      validated: false,
      authCode: "",
      imgUrl: "",
      icon: "",
      loginFailureMsg: "",
      showPass: false,
      webCheckoutConfig: false
    };
    this.handleLogin = this.handleLogin.bind(this);
    this.handleForgotPassword = this.handleForgotPassword.bind(this);
    this.handlePasswordVisibility = this.handlePasswordVisibility.bind(this);
  }

  componentDidMount() {
    let globalUrl = process.env.REACT_APP_GLOBAL_URL;
    localStorage.setItem("globalUrl", globalUrl);
    localStorage.setItem("qkrLoginUrl", QKR_LOGIN_URL);
  }

  handleChangeEmail(event) {
    const updatedEmail = event?.target?.value?.replace(
      REGEX_VALIDATIONS.removeSpace,
      ""
    );
    if (updatedEmail === this.state.email) return;
    this.setState({ email: updatedEmail });
  }

  handleForgotPassword() {
    this.context.navigateTo(ROUTES.FORGOT_PASSWORD);
  }

  handleChangePassword(event) {
    const updatedPassword = event?.target?.value?.replace(
      REGEX_VALIDATIONS.removeSpace,
      ""
    );
    if (updatedPassword === this.state.password) return;
    this.setState({ password: updatedPassword });
  }

  handlePasswordVisibility() {
    this.setState((prevState) => ({
      showPass: !prevState.showPass,
    }));
  }

  async handleLogin(e) {
    try {
      if (e) e.preventDefault();
      this.setState({ validated: true });
      let headers = {
        "Content-Type": API_CONTEXT_TYPE,
        "X-Auth-Token": API_AUTH_TOKEN,
      };
      let api = new SecureAPI();
      let payload = {
        emailAddress: this.state.email,
        password: this.state.password,
      };
      const response = await api.request(
        API_URL.LOGIN,
        API_METHOD_POST,
        headers,
        payload
      );
      if (response.status.code === "Y") {
        this.setState(
          {
            success: response.status.code,
            role: response.body.roles[0],
            emailIdData: response.body.emailId,
            merchantIdData: response.body.merchantId,
            firstName: response.body.firstName,
            authCode: response.body.authorization,
            lastName: response.body.lastName,
          },
          () => {
            if (response.body.roles[0] === ADMIN_TYPE.SCHOOL_ADMIN) {
              this.handleGetSchoolName(
                this.state.merchantIdData,
                response.body.authorization
              );
            }
          }
        );
      }

      if (response.status.code === "N") {
        this.setState({ success: false, loginFailure: true });
      }
    } catch (err) {
      if (err.errorCode === ACCOUNT_LOCKED && err.code === "N") {
        this.setState({
          success: false,
          loginFailure: true,
          loginFailureMsg: err.message,
        });
      } else if (err.code === "N") {
        this.setState({
          success: false,
          loginFailure: true,
          loginFailureMsg: LOGINPAGE_CONSTANTS.INVALID_USERNAME,
        });
      }
    }
  }

  handleGetSchoolName(merchant, authCode) {
    let globalUrl = localStorage.getItem("globalUrl");
    let migrateUrl = globalUrl + "/skiply-merchantdata/merchant/" + merchant;
    fetch(migrateUrl, {
      method: API_METHOD_GET,
      headers: {
        "Content-Type": API_CONTEXT_TYPE,
        Authorization: authCode,
        "X-Auth-Token": API_AUTH_TOKEN,
        Accept: API_CONTEXT_TYPE,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        localStorage.setItem("schoolDataProvided", response.schoolDataProvided);
        this.setState({
          schoolName: response.body.name,
          imgUrl: response.body.imageUrl,
          icon: response.body.icon,
          webCheckoutConfig : response.body.webCheckoutConfig?.enabled,
        });
      });
  }

  handleCapsLock(e) {
    let kc = e.keyCode ? e.keyCode : e.which;
    let sk = e.shiftKey ? e.shiftKey : kc === 16;
    if ((kc >= 65 && kc <= 90 && !sk) || (kc >= 97 && kc <= 122 && sk))
      document.getElementById("capsMsgId").style.display = "block";
    else document.getElementById("capsMsgId").style.display = "none";
  }

  handleCapsLockOff(e) {
    document.getElementById("capsMsgId").style.display = "none";
  }

  render() {
    if (
      this.state.success === "Y" &&
      (this.state.role === ADMIN_TYPE.SUPER_ADMIN ||
        this.state.role === ADMIN_TYPE.SALES_ADMIN)
    ) {
      localStorage.setItem("isAuth", "true");
      let globalUrl = localStorage.getItem("globalUrl");
      localStorage.setItem("role", this.state.role);
      localStorage.setItem("bearer", this.state.authCode);
      localStorage.setItem("bearerProgressPercentage", this.state.authCode);
      localStorage.setItem("emailIdValue", this.state.emailIdData);
      localStorage.setItem("firstName", this.state.firstName);
      localStorage.setItem("lastName", this.state.lastName);
      localStorage.setItem("icon", this.state.imgUrl);
      localStorage.setItem(
        "studentDataUrl",
        globalUrl + "/skiply-merchantdata/studentdata"
      );
      localStorage.setItem(
        "studentDataUrlConf",
        globalUrl + "/skiply-merchantdata/schoolconf"
      );
      localStorage.setItem(
        "schoolProd",
        globalUrl + "/skiply-merchantdata/merchant/getmerchantid"
      );
      localStorage.setItem("migrate", globalUrl + "/skiply-merchantdata");
      localStorage.setItem(
        "userProfile",
        globalUrl + "/skiply-portaluserprofile/portalprofile"
      );
      this.context.navigateTo(ROUTES.MAIN_LANDING_PAGE);
    }
    if (
      this.state.success === "Y" &&
      this.state.role === ADMIN_TYPE.SCHOOL_ADMIN &&
      this.state.schoolName !== ""
    ) {
      let globalUrl = localStorage.getItem("globalUrl");
      localStorage.setItem("isAuth", "true");
      localStorage.setItem("icon", this.state.icon);
      localStorage.setItem("schoolAdminMerchantId", this.state.merchantIdData);
      localStorage.setItem("role", this.state.role);
      localStorage.setItem("bearer", this.state.authCode);
      localStorage.setItem("bearerProgressPercentage", this.state.authCode);
      localStorage.setItem("schoolAdminSchoolName", this.state.schoolName);
      localStorage.setItem("webCheckoutConfig", this.state.webCheckoutConfig);
      localStorage.setItem("firstName", this.state.firstName);
      localStorage.setItem("lastName", this.state.lastName);
      localStorage.setItem("emailIdValue", this.state.emailIdData);
      localStorage.setItem("migrate", globalUrl + "/skiply-merchantdata");
      localStorage.setItem(
        "studentDataUrl",
        globalUrl + "/skiply-merchantdata/studentdata"
      );
      localStorage.setItem(
        "studentDataUrlConf",
        globalUrl + "/skiply-merchantdata/schoolconf"
      );
      localStorage.setItem(
        "userProfile",
        globalUrl + "/skiply-userprofile/portalprofile"
      );
      this.context.navigateTo(ROUTES.STUDENT_DATA);
    }
    if (this.state.success === "N") {
      this.setState({ success: false });
      this.setState({ loginFailure: true });
    }
    const { validated } = this.state;
    return (
      <LoginWrapper>
        <div className="login-container">
          <div className="login-header">{LOGINPAGE_CONSTANTS.HEADER}</div>
          <Form validated={validated}>
            <Form.Group
              as={Row}
              className="mt-4"
              controlId="formHorizontalEmail"
            >
              <Col sm={16} className="login-section">
                <Form.Floating className="flex-grow-1">
                  <Form.Control
                    id="emailVal"
                    value={this.state.email}
                    type="email"
                    key="login-email"
                    className="login-text-field"
                    placeholder={LOGINPAGE_CONSTANTS.LOGIN_EMAIL}
                    onChange={this.handleChangeEmail.bind(this)}
                    required
                  />
                  <label htmlFor="emailVal">
                    {LOGINPAGE_CONSTANTS.LOGIN_EMAIL}
                  </label>
                </Form.Floating>
                <Form.Control.Feedback type="invalid">
                  <WarningLogo />
                  {LOGINPAGE_CONSTANTS.INVALID_EMAIL}
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group
              as={Row}
              className="mt-3"
              controlId="formHorizontalPassword"
            >
              <Col sm={16} className="login-section">
                <InputGroup className="mb-3">
                  <Form.Floating className="flex-grow-1">
                    <Form.Control
                      id="loginPass"
                      value={this.state.password}
                      type={this.state.showPass ? "text" : "password"}
                      key="pass"
                      className="login-text-field"
                      placeholder={LOGINPAGE_CONSTANTS.LOGIN_PASSWORD}
                      onKeyPress={this.handleCapsLock}
                      onChange={this.handleChangePassword.bind(this)}
                      onBlur={this.handleCapsLockOff}
                      required
                    />
                    <label htmlFor="loginPass">
                      {LOGINPAGE_CONSTANTS.LOGIN_PASSWORD}
                    </label>
                  </Form.Floating>
                  <InputGroup.Text
                    onClick={this.handlePasswordVisibility}
                    style={{ cursor: "pointer" }}
                  >
                    {this.state.showPass ? <EyeHideLogo /> : <EyeOpenLogo />}
                  </InputGroup.Text>
                </InputGroup>
              </Col>
              <Col sm={12} className="d-flex justify-content-center">
                <Form.Text>
                  {this.state.loginFailure ? (
                    <p className="login-failure">
                      {this.state.loginFailureMsg}
                    </p>
                  ) : null}
                </Form.Text>
                <Form.Text>
                  <p
                    id="capsMsgId"
                    style={{
                      width: "352px",
                      margin: "8px auto",
                      color: "red",
                      display: "none",
                    }}
                  >
                    {LOGINPAGE_CONSTANTS.CAPS_LOCK}
                  </p>
                </Form.Text>
              </Col>
              <fieldset></fieldset>
              <Col sm={10} className="forgot-password-container mb-3 mt-1">
                <Button
                  variant="link"
                  as={Link}
                  className="forgot-password"
                  to={ROUTES.FORGOT_PASSWORD}
                  tabIndex="0"
                >
                  {LOGINPAGE_CONSTANTS.FORGOT_PASSWORD}
                </Button>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Col sm={16}>
                <Link
                  to={this.state.success ? ROUTES.STUDENT_DATA : null}
                  className="nav-link"
                >
                  <Button
                    className="login-button"
                    onClick={this.handleLogin}
                    variant="primary"
                    type="submit"
                  >
                    {LOGINPAGE_CONSTANTS.LOGIN_BUTTON}
                  </Button>
                </Link>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Col sm={16}>
                <a href={ROUTES.HOME} className="nav-link">
                  <Button className="back-button">
                    {LOGINPAGE_CONSTANTS.BACK_BUTTON}
                  </Button>
                </a>
              </Col>
            </Form.Group>
          </Form>
        </div>
      </LoginWrapper>
    );
  }
}

export default LoginPage;
